window.kickstartjs.extend({
    form: {
        submit: function(formRef, onSuccess, onError) {
            var form = jQuery(formRef);
            var type = form.attr('method');
            type = (typeof type !== 'undefined') ? type.toUpperCase() : 'POST';
            var url = form.attr('action');
            if (typeof url === 'undefined') {
                console.log('Was not able to read the action url from form.');
                return;
            }

            onError = (typeof onError !== 'undefined') ? onError : window.kickstartjs.form.onError;
            onSuccess = (typeof onSuccess !== 'undefined') ? onSuccess : window.kickstartjs.form.onSuccess;

            var formData = new FormData(form[0]);
            console.log(formData);

            jQuery.ajax({
                type: type,
                dataType: 'json',
                url: url,
                data: formData,
                contentType: false,
                processData: false,
                success: function(data, textStatus, jqXHR) {
                    console.log('connection was successful');
                    if(data) {
                        console.log(data);
                        onSuccess(form, data, textStatus, jqXHR);
                    } else {
                        console.log('no data was send!');
                    }
                    window.kickstartjs.form.enable(form);
                },
                error: function(data, textStatus, jqXHR) {
                    console.log('an error appeared during connection');
                    console.log(textStatus);
                    onError(form, data, textStatus, jqXHR);
                    window.kickstartjs.form.enable(form);
                }
            });

            window.kickstartjs.form.disable(form);
        },

        disable: function(form) {
            jQuery(form).find('input, textarea, button, select').attr('disabled', 'disabled');
            jQuery(form).addClass('disabled');
        },

        enable: function(form) {
            jQuery(form).find('input, textarea, button, select').removeAttr('disabled');
            jQuery(form).removeClass('disabled');
        },

        onSuccess: function(form, data, textStatus, jqXHR){
            if(typeof data.validation != 'undefined' && data.validation == false && data.messages) {
                console.log('show validation errors');
                window.kickstartjs.form.showValidationMessages(data.messages, form);
                return;
            }

            if(data.success) {
                jQuery(form).replaceWith('<div class="form-success">' + data.success + '</div>');
                return;
            }

            var errors = jQuery(form).find(".form-errors");

            if(data.error) {
                errors.html(data.error);
            }
            //TODO add a message

            errors.removeClass('hidden');
        },

        onError: function(form, data, textStatus, jqXHR) {
            var errors = jQuery(form).find(".form-errors");
            //TODO add default message
            errors.removeClass('hidden');
        },

        showValidationMessages: function(messages, form) {
            console.log(messages);
            jQuery.each(messages, function(id, message) {
                var field = form.find('#' + id).parent();
                field.append('<label id="'+id+'-error" class="error" for="'+id+'">'+message+'</label>');
            });
        }
    }

});

jQuery(document).ready(function($) {
    $('.kickstart-form').validate({
        submitHandler: function(form) {
            console.log('starting submission');
            window.kickstartjs.form.submit(form);
        }
    });

    //TODO add translated validation messages
});